<fcom-button
  data-testid="mmb-review-route-back-button"
  class="pr-large-t"
  [attr.title]="'actions.back' | finLocalization"
  [icon]="{
    name: SvgLibraryIcon.ARROW_LEFT,

    position: IconPosition.LEFT,
  }"
  [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
  [text]="'MMB.reviewPage.backButton' | finLocalization"
  (clickBtn)="backToMmb()"
/>
<fin-booking-plain-header-area [title]="'MMB.reviewPage.shoppingCartTitle' | finLocalization" />
@if (showLoader()) {
  <ng-container>
    <fcom-loader [loaderType]="LoaderTheme.EMBEDDED" [paragraph]="'MMB.cart.loading'" />
  </ng-container>
}

@if (!showLoader()) {
  @if ((cartIsEmpty$ | async) === true) {
    <fcom-notification>{{ 'MMB.cart.cartIsEmpty' | finLocalization }}</fcom-notification>
  } @else {
    <fin-included-products
      class="block mr-xsmall-t"
      [booking]="order$ | async"
      [useCabinClass]="false"
      [titleTranslationKey]="'purchaseSummaryItemNames.ancillaries'"
      [showAdditionalTitle]="true"
      [expandOpen]="true"
      [servicesToShow]="services$ | async"
      [groupServicesByBound]="true"
      [serviceModifyProgress]="serviceModifyProgress()"
      [showPendingServicesInTitles]="true"
      (selectProduct)="modifyClicked($event)"
      (removeProduct)="removeProduct($event)"
      [mode]="AllowedActionsMode.CART"
    />
    <fin-section-review
      class="mr-xsmall-t purchase-review-total-prices"
      [title]="'price.grandTotal' | finLocalization"
      [endTitle]="(order$ | async)?.prices?.unpaid?.total?.total?.totalAmount | finPrice: { useSymbol: false }"
      [noContent]="true"
      [noButton]="true"
    />
    @if (!disableTermsAndConditionCheckbox) {
      <fin-form-fields>
        <fin-input-checkbox
          class="block pr-xsmall-t pr-large-b"
          [containerClass]="'flex'"
          [labelClass]="'font-body-1 inline-block pr-xxsmall-l'"
          [group]="reviewForm"
          [modelName]="'confirm'"
          [name]="'confirm'"
          [hideError]="true"
          [required]="true"
          [innerHtml]="(termAndCondition$ | async)?.teaserText"
          (checkboxChange)="acceptTerms($event)"
        />
      </fin-form-fields>
    }
  }
}
<fcom-cta-button
  data-testid="manage-booking-review-route-cta-button"
  *finLet="cartIsEmpty$ | async as cartIsEmpty"
  [title]="(!cartIsEmpty ? 'purchase.review.proceed' : 'MMB.modifyYourTrip.labels.addExtras') | finLocalization"
  [disabled]="(formValid$ | async) === false"
  [visible]="!showLoader()"
  [position]="ButtonPosition.GRID_FULL"
  [loading]="serviceModifyProgress().modifyInProgress"
  (buttonClicked)="payOrAdd(cartIsEmpty)"
>
  @if (cartIsEmpty) {
    <span>
      {{ 'MMB.cart.noItemsInCart' | finLocalization }}
    </span>
  }
  @if (!cartIsEmpty) {
    <span class="gray-50-text">{{ 'price.continueButtonTotal' | finLocalization }}: </span>
    <span class="font-body-1">{{
      (order$ | async)?.prices?.unpaid?.total?.total?.totalAmount | finPrice: { useSymbol: false }
    }}</span>
  }
</fcom-cta-button>
